// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"b60a148e","236":"911cd794","887":"927e9c4f"}[chunkId] + ".chunk.js";
};